var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-indicator",class:{ 'progress-indicator--horizontal': _vm.horizontal, small: _vm.small }},_vm._l((_vm.steps),function(step,idx){return _c('div',{key:idx,staticClass:"progress-indicator__step",class:{
      'progress-indicator__step--completed':
        _vm.completed || idx + 1 < _vm.activeIndex,
      'progress-indicator__step--active':
        !_vm.completed && _vm.activeIndex === idx + 1,
    },on:{"click":function($event){return _vm.handleStepperClick(step)}}},[_c('icon',{attrs:{"class-name":"progress-indicator__step__icon","name":"check"}}),_vm._v(" "+_vm._s(step.title)+" ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }